import StrapAqua from "../images/customisation-assets/Strap_Aqua.png";
import StrapBlue from "../images/customisation-assets/Strap_Blue.png";
import StrapBrown from "../images/customisation-assets/Strap_Brown.png";
import StrapKhaki from "../images/customisation-assets/Strap_Khaki.png";
import StrapOrange from "../images/customisation-assets/Strap_Orange.png";
import StrapRed from "../images/customisation-assets/Strap_Red.png";
import StrapSand from "../images/customisation-assets/Strap_Sand.png";
import StrapSteelBlack from "../images/customisation-assets/Strap_Steel_Black.png";
import StrapSteelSilver from "../images/customisation-assets/Strap_Steel_Silver.png";
import StrapWhite from "../images/customisation-assets/Strap_White.png";
import OptionSteelBlack from "../images/customisation-option-icons/steel_black.png";
import OptionSteelSilver from "../images/customisation-option-icons/steel_silver.png";

// Thumbnails
import StrapAquaThumb from "../images/customisation-asset-thumbnails/Strap_Aqua_50x50.png";
import StrapBlueThumb from "../images/customisation-asset-thumbnails/Strap_Blue_50x50.png";
import StrapBrownThumb from "../images/customisation-asset-thumbnails/Strap_Brown_50x50.png";
import StrapKhakiThumb from "../images/customisation-asset-thumbnails/Strap_Khaki_50x50.png";
import StrapOrangeThumb from "../images/customisation-asset-thumbnails/Strap_Orange_50x50.png";
import StrapRedThumb from "../images/customisation-asset-thumbnails/Strap_Red_50x50.png";
import StrapSandThumb from "../images/customisation-asset-thumbnails/Strap_Sand_50x50.png";
import StrapWhiteThumb from "../images/customisation-asset-thumbnails/Strap_White_50x50.png";
import StrapSteelBlackThumb from "../images/customisation-asset-thumbnails/Strap_Steel_Black_50x50.png";
import StrapSteelSilverThumb from "../images/customisation-asset-thumbnails/Strap_Steel_Silver_50x50.png";
import { SelectionColours } from "./selection-colors";

export const STRAP_OPTIONS = {
  steelBlack: {
    title: "Steel Black",
    watchLayerAsset: StrapSteelBlack,
    watchLayerThumbnail: StrapSteelBlackThumb,
    selectionAsset: {
      type: "asset",
      asset: OptionSteelBlack,
    },
  },
  steelSilver: {
    title: "Steel",
    watchLayerAsset: StrapSteelSilver,
    watchLayerThumbnail: StrapSteelSilverThumb,
    selectionAsset: {
      type: "asset",
      asset: OptionSteelSilver,
    },
  },
  aqua: {
    title: "Aqua",
    watchLayerAsset: StrapAqua,
    watchLayerThumbnail: StrapAquaThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.AQUA],
    },
  },
  blue: {
    title: "Blue",
    watchLayerAsset: StrapBlue,
    watchLayerThumbnail: StrapBlueThumb,
    selectionAsset: {
      type: "color",
      colors: ["blue"],
    },
  },
  brown: {
    title: "Brown",
    watchLayerAsset: StrapBrown,
    watchLayerThumbnail: StrapBrownThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.BROWN],
    },
  },
  khaki: {
    title: "Green",
    watchLayerAsset: StrapKhaki,
    watchLayerThumbnail: StrapKhakiThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.EMERALD],
    },
  },
  white: {
    title: "White",
    watchLayerAsset: StrapWhite,
    watchLayerThumbnail: StrapWhiteThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.WHITE],
    },
  },
  orange: {
    title: "Orange",
    watchLayerAsset: StrapOrange,
    watchLayerThumbnail: StrapOrangeThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.ORANGE],
    },
  },
  red: {
    title: "Red",
    watchLayerAsset: StrapRed,
    watchLayerThumbnail: StrapRedThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.RED],
    },
  },
  sand: {
    title: "Sand",
    watchLayerAsset: StrapSand,
    watchLayerThumbnail: StrapSandThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.SAND],
    },
  },
};
